import React from "react";
import { Outlet } from "react-router-dom";
import "./MangaLayout.css";

const MangaLayout = () => {
  return (
    <div className="MangaLayout">
      <Outlet />
    </div>
  );
};

export default MangaLayout;
